import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  Renderer2,
  RendererStyleFlags2,
  ViewChild,
} from '@angular/core';

import { SpaDayLoadDTO } from '@api';

@Component({
  selector: 'spa-report-spa-bar-chart',
  templateUrl: './report-bar-chart.component.html',
  styleUrls: ['./report-bar-chart.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportBarChartComponent {
  private readonly element = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  @Input() loads: SpaDayLoadDTO | undefined;
  @ViewChild('spaDiagram') spaDiagram: ElementRef | undefined;

  indexOfHoveredBar = -1;
  parentXPosition: number | null = null;

  availableGreen = getComputedStyle(document.documentElement).getPropertyValue('--green-4');
  availableYellow = getComputedStyle(document.documentElement).getPropertyValue('--yellow-3');
  availableOrange = getComputedStyle(document.documentElement).getPropertyValue('--orange-3');
  availableGrey = getComputedStyle(document.documentElement).getPropertyValue('--grey-3');

  public xAxisTicks = Array.from({ length: 11 }, (_, i) => {
    const value = i * 10;
    const position = i * 10;
    return {
      value: value, // value to be shown
      position: position, // calculate position as percentage of axis width
    };
  });

  get xPosition(): number {
    return this.spaDiagram?.nativeElement?.getBoundingClientRect().x;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.parentXPosition = this.xPosition;
  }

  onHover(event: MouseEvent): void {
    const mouseX = event.clientX;
    this.renderer.setStyle(
      this.element.nativeElement,
      `--tooltip-x-position`,
      mouseX - (this.parentXPosition ?? 0) + 'px',
      RendererStyleFlags2.DashCase,
    );
  }

  enteredDiagramElement(i: number) {
    if (!this.parentXPosition) {
      this.parentXPosition = this.xPosition;
    }

    this.indexOfHoveredBar = i;
  }

  leftDiagramElement() {
    this.indexOfHoveredBar = -1;
  }
}

export enum DiagramMarking {
  arrow,
  line,
}
